<template>
    <div :class="['page terms',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: infoFontColor }"></div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'faq',
    mixins: [ pageOn ],
    computed: {
        client_id () { return this.$store.state.client_id },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        infoFontColor () { return this.$store.state.infoFontColor },
        twoele () { return this.$store.state.twoele }
    },
    components: {
        VHeader
    },
    mounted () {
        WebSoc.SEND({ t: 'getFAQs', data: { client_id: this.client_id } },faq => {
            this.$el.querySelector('.page-content').innerHTML = faq + '<a href="https://twoelephants.co.uk"><img src="'+this.twoele+'" style="width: 100%;" /></a>'
        })
    }
}

</script>

<style lang="scss">

</style>